import { addDays, format } from 'date-fns'

/**
 * Get the next delivery date based on Monday and Thursday
 */
export const getNextDeliveryDate = () => {
  const today = new Date()
  const dayOfWeek = today.getDay()
  const targetDay = dayOfWeek >= 2 && dayOfWeek <= 4 ? 4 : 1 // Next Monday (1) or Thursday (4)
  const daysUntilNext = (targetDay - dayOfWeek + 7) % 7
  const nextDate = addDays(today, daysUntilNext)

  return format(nextDate, 'yyyy-MM-dd')
}